import Cookies from "js-cookie"

import { isGID, type GID } from "@unlikelystudio/commerce-connector"

import { geti18nLocale } from "~/lib/i18n/utils/get-processed-locale"
import { getRecentlyViewedProducts } from "~/providers/RecentlyViewedProvider/utils/get-products"
import type { CookieProps, ProductItem, TDB } from "~/providers/RecentlyViewedProvider/utils/types"
import { objectEntries } from "~/utils/object-entries"

// Timestamp 24h
const DAY_TIMESTAMP = 1000 * 60 * 60 * 24

/**
 * Update DB Existing Item date
 * @param uid
 * @param locale
 * @param DB
 */
function updateUID(id: string, locale: string, DB: TDB) {
  const now = Date.now()
  const i18nLocale = geti18nLocale(locale)
  const index = DB[i18nLocale]?.findIndex((n: ProductItem) => n?.id === id)
  if (DB[i18nLocale][index]) DB[i18nLocale][index]!.date = now
}

/**
 * Add DB new Item
 * @param uid
 * @param locale
 * @param DB
 */
function addUID(id: GID, locale: string, DB: TDB) {
  if (!isGID(id)) return

  const i18nLocale = geti18nLocale(locale)
  const item: ProductItem = {
    id,
    date: Date.now(),
  }

  DB[i18nLocale]?.push(item)

  return DB
}

export function addProductViewed(gid: GID, locale: string, ctx: CookieProps) {
  const i18nLocale = geti18nLocale(locale)
  const { expireDays, maxProducts = 5, cookieAge, cookieKey } = ctx

  if (!expireDays || !cookieKey || !isGID(gid)) return

  const DB = getRecentlyViewedProducts(ctx)

  if (!DB[i18nLocale]) DB[i18nLocale] = []

  if (DB[i18nLocale].findIndex((n: ProductItem) => n?.id === gid) === -1) addUID(gid, i18nLocale, DB)
  else updateUID(gid, i18nLocale, DB)

  // Filter too old items and delete it
  for (const [key, loc] of objectEntries(DB)) {
    DB[key] = loc.filter((n) => {
      return Date.now() < n.date + expireDays * DAY_TIMESTAMP
    })
  }

  // Reorder
  for (const [, loc] of objectEntries(DB)) {
    loc.sort(function (a, b) {
      return b.date - a.date
    })
  }

  // Delete older items if > MAX_PRODUCTS_RECENTLY_VIEWED

  for (const [, loc] of objectEntries(DB)) {
    if (loc.length > maxProducts) {
      DB[i18nLocale] = loc.slice(0, maxProducts)
    }
  }

  Cookies.set(cookieKey, JSON.stringify(DB), {
    expires: cookieAge,
  })
}
